import { render, staticRenderFns } from "./SMSLog.vue?vue&type=template&id=2b8ba8d6&"
import script from "./SMSLog.vue?vue&type=script&lang=js&"
export * from "./SMSLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports